<template>
    <div>
        <keep-alive>
            <router-view/>
        </keep-alive>
    </div>
</template>

<script>
    export default {
        name: "Pre_Player_Explore",
    }
</script>

<style scoped>

</style>